/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerConfig } from '@pages/BuyInsurancePage/config/header.config';

import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IHeaderNavContentMethods extends IPluginMethodMap {
  getHeaderNavContent(): any;
}

export class HeaderNavContentService implements IAgentPlugin {
  readonly methods: IHeaderNavContentMethods;

  constructor() {
    this.methods = {
      getHeaderNavContent: this.getProps.bind(this),
    };
  }

  async getProps() {
    let buttonItems = await this.getGetHeaderButton();
    console.log(`buttonItems::`, buttonItems);
    return buttonItems;
  }

  private async getGetHeaderButton() {
    let user = await getWhoamiSrv()?.whoAmI();
    console.log(`user role`, user);
    if (user?.whoami === 'purchaser') {
      return { ...(headerConfig?.loginButton || {}) };
    } else {
      return { ...(headerConfig?.buttonItem || {}) };
    }
  }
}
